import { useHistory, useParams } from "react-router";
import { useContext } from "react";
import { useManageFeatureInstanceDetails } from "entity-app/hooks/feature-details-page";
import {
  isPermissionNotGrantted,
  ProjectContext
} from "context/ProjectProvider";
import { ProjectPermissionEnum } from "constants/index";
import { FeatureTypes } from "entity-app/constants";
import useFeatureLogNavReader from "hooks/use-feature-log-nav-reader";
import BidPackageDetails from "./bid-package-details";
import FeatureHeader from "./components/bid-package-header";
import usePageTitle from "hooks/use-page-title";
import { formatEntityTitle } from "config/page-titles";

function PreconstructionDetailsPage() {
  const history = useHistory();
  const { projectId, bidPackageId } = useParams() as any;
  const { tokenContents } = useContext(ProjectContext);

  const { featureInstanceData, actions } = useManageFeatureInstanceDetails(
    bidPackageId,
    FeatureTypes.BID_PACKAGE
  );

  usePageTitle(
    formatEntityTitle(featureInstanceData?.number, featureInstanceData?.title)
  );

  const cannotWriteAccessOfBidPackage = isPermissionNotGrantted(
    ProjectPermissionEnum.BidPackageWrite,
    tokenContents?.role ?? ""
  );

  const navigator = useFeatureLogNavReader({
    feature: "bid-packages",
    projectId,
    currentId: bidPackageId
  });

  const goBackToList = () => {
    history.push(`/project/${projectId}/bid-packages`);
  };

  return (
    <div className="grow flex-col bg-ciq-gray-50">
      <FeatureHeader
        title="Bid Package Details"
        actions={actions}
        number={featureInstanceData?.number}
        headerTitle={featureInstanceData?.title}
        status={featureInstanceData?.feature_workflow_instance?.milestone_state}
        disabled={cannotWriteAccessOfBidPackage}
        goBackToList={goBackToList}
        feature="BID_PACKAGE"
        featureInstanceData={featureInstanceData}
        navigator={navigator}
      />

      <BidPackageDetails
        key={bidPackageId}
        featureInstanceData={featureInstanceData}
        actions={actions}
        featureId={bidPackageId}
      />
    </div>
  );
}

export default PreconstructionDetailsPage;
